import { FileIcon, MovieFileIcon } from '@/components/Icons';

import { getFileViewerType } from '../lib/getFileViewerType';
import { getFileExtension } from '@/lib/getFileExtension';
import { FileEntity } from '@/shared/interfaces';

const iconStyleClass = 'h-6 w-6 text-white/70';
const iconWrapperClass =
    'flex h-full w-full items-center justify-center rounded-xl bg-gray-700';

type ThumbnailItemProps = {
    fileEntity: FileEntity;
};

export const ThumbnailItem = ({ fileEntity }: ThumbnailItemProps) => {
    const extension = getFileExtension(fileEntity.fileName);
    const viewerType = getFileViewerType(extension);
    const fileUrl = `${window.location.origin}/api/files/${fileEntity.guid}`;

    if (viewerType === 'image') {
        return (
            <img
                src={fileUrl}
                alt={fileEntity.fileName}
                className="h-full w-full object-cover"
            />
        );
    }

    if (viewerType === 'video') {
        return (
            <div className={iconWrapperClass}>
                <MovieFileIcon className={iconStyleClass} />
            </div>
        );
    }

    return (
        <div className={iconWrapperClass}>
            <FileIcon className={iconStyleClass} />
        </div>
    );
};
